import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSetState from '../../hooks/useSetState';
import Spin from '../../components/loading';
import { permissionHelper } from '../../utils';
import submitForm from '../../utils/submitForm';
import TakeawayFinancialReportsFilter from './Filter/TakeawayFinancilReportFilter';
import TakeawayFinancialReportsList from './List';
import ENUMS from '../../enums';
import { getAllCafeNamesForPanel } from '../../redux/cafes/actions';
import { getTakeawayFactor } from '../../redux/takeaway/actions';

const TakeawayCAfesFinancialReport = () => {
  const [controls, setControls] = useSetState({
    filter: '',
    sort: { sortType: 'desc', sortBy: 'startDate', sortQuery: '', filterQuery: '' },
    query: '',
    pageNumber: 1,
    pageSize: 10,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const dispatch = useDispatch();

  const { cafeNamesList, takeawayFactorList } = useSelector(state => ({
    cafeNamesList: state.cafesReducer.cafeNamesList,
    takeawayFactorList: state.takeawayReducer.takeawayFactorList,
  }));

  const hasRseeAdminPermission = permissionHelper.hasUserPermission(
    ENUMS.PERMISSIONS.values
      .VIEW_CAFE_DATES_LIST_FOR_ADMIN,
  );


  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${controls.sort.sortQuery || 'startDate-desc'}`;
      if (controls.sort.filterQuery) {
        query += '&' + controls.sort.filterQuery;
      }
      return query;
    }
  };

  const onPageChanged = pageNumber => {
    onChangeValue('pageNumber', pageNumber);
    const query = buildSearchQuery(pageNumber, controls.pageSize);
    dispatch(getReservationTimingList(query));
  };

  const sortTable = (columnName) => {
    const sortType = controls.sort.sortType === 'asc' ? 'desc' : 'asc';
    onChangeValue('sort', { ...controls.sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(1, controls.pageSize);
    dispatch(getTakeawayFactor(searchQuery));
  };

  const applyFilters = (event, cafeIds) => {
    event.preventDefault();
    const queryString = submitForm(event,
      controls.selectedRegions,
      controls.selectedAmenities,
      cafeIds);
    onChangeValue('sort', { ...controls.sort, filterQuery: queryString });
    console.log(queryString)
  };

  const resetForm = () => {
    onChangeValue('pageNumber', 1);
    onChangeValue('sort', { ...controls.sort, filterQuery: '' });
  };

  const getTakeawayList = (pageNumber, pageSize) => {
    const query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    dispatch(getTakeawayFactor(query))
      .then(result => {
        setTotalRecords(result.payload.totalRecords);
        onChangeValue('pageNumber', result.payload.pageNumber);
        onChangeValue('pageSize', result.payload.pageSize);
      })
      .catch(error => console.log('error', error));
  };
  
  useEffect(() => {
    if (hasRseeAdminPermission) {
      // this action is for normal cafes list, change it for takeaway cafes when api ready
      dispatch(getAllCafeNamesForPanel())
    }
  }, []);

  useEffect(() => {
    const sortQuery = `${controls.sort.sortBy}-${controls.sort.sortType}`;
    onChangeValue('sort', { ...controls.sort, sortQuery });
  }, [controls.sort.sortType]);

  useEffect(() => {
    if (controls.sort.sortQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.sortQuery]);

  useEffect(() => {
    if (controls.sort.filterQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.filterQuery]);

  return (
    <Spin>
      <section>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            {locales('titles.show.takeaway.cafes.financial.report')}
          </h3>
        </div>
        <TakeawayFinancialReportsFilter
          data={cafeNamesList}
          hasRseeAdminPermission={hasRseeAdminPermission}
          applyFilters={applyFilters}
          resetForm={resetForm}
          getTakeawayList={getTakeawayList}
          pageNumber={controls.pageNumber}
          pageSize={controls.pageSize} />

        <TakeawayFinancialReportsList
          sortTable={sortTable}
          data={takeawayFactorList}
          onPageChange={onPageChanged}
          pageNumber={controls.pageNumber}
          pageSize={controls.pageSize}
          sortType={controls.sort.sortType}
          />
      </section>
    </Spin>
  );
}

export default TakeawayCAfesFinancialReport;